import { json } from "utils/http/client";

const getOrgId = () => JSON.parse(localStorage.getItem("organization") || "{}")?.id;

const getSiteId = () => Number(localStorage.getItem("site"));

const getRequiredContext = () => {
  const orgId = getOrgId();
  const siteId = getSiteId();

  if (!orgId) {
    throw new Error("Organization not found in local storage.");
  }

  if (!siteId) {
    throw new Error("Site not found in local storage.");
  }

  return { orgId, siteId };
};

export const BoQApi = {
  getSections: async (site = null) => {
    const { orgId, siteId } = getRequiredContext();
    const response = await json(`/boq/org/${orgId}/sections/`, {
      method: "GET",
      params: { site: site || siteId },
    });

    return Array.isArray(response) ? response : response?.data || [];
  },

  getItemsBySection: async (sectionId) => {
    const { orgId } = getRequiredContext();
    const response = await json(`/boq/org/${orgId}/items/`, {
      method: "GET",
      params: { section_id: sectionId },
    });

    return Array.isArray(response) ? response : response?.data || [];
  },

  getSectionsWithItems: async (site = null) => {
    const sections = await BoQApi.getSections(site);
    const itemsBySection = await Promise.all(
      sections.map(async (section) => ({
        sectionId: section.id,
        items: await BoQApi.getItemsBySection(section.id),
      }))
    );

    return sections.map((section) => ({
      ...section,
      items: itemsBySection.find((entry) => entry.sectionId === section.id)?.items || [],
    }));
  },

  createSection: async ({ sectionName, order }) => {
    const { orgId, siteId } = getRequiredContext();
    return json(`/boq/org/${orgId}/sections/`, {
      method: "POST",
      body: {
        site: siteId,
        order,
        section_name: sectionName,
      },
    });
  },

  updateSection: async (sectionId, payload) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/sections/${sectionId}/`, {
      method: "PUT",
      body: payload,
    });
  },

  deleteSection: async (sectionId) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/sections/${sectionId}/`, {
      method: "DELETE",
    });
  },

  createItem: async (payload) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/items/`, {
      method: "POST",
      body: payload,
    });
  },

  updateItem: async (boqItemId, payload) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/items/${boqItemId}/update/`, {
      method: "PATCH",
      body: payload,
    });
  },

  deleteItem: async (boqItemId) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/items/${boqItemId}/`, {
      method: "DELETE",
    });
  },

  linkItemToTask: async ({ task_id, boq_item_id }) => {
    const { orgId } = getRequiredContext();
    return json(`/boq/org/${orgId}/link-task/`, {
      method: "POST",
      body: {
        task_id,
        boq_item_id,
      },
    });
  },

  getItemHistory: async (boqItemId) => {
    const { orgId } = getRequiredContext();
    const response = await json(`/boq/org/${orgId}/items/${boqItemId}/history/`, {
      method: "GET",
    });
    return Array.isArray(response?.data) ? response.data : [];
  },

  generateTasks: async () => {
    const { orgId, siteId } = getRequiredContext();
    return json(`/task/org/${orgId}/boq-generate-tasks/`, {
      method: "POST",
      body: { site_id: siteId },
    });
  },
};
